import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1f3911ff&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=1f3911ff&lang=scss&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=1f3911ff&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3911ff",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f3911ff')) {
      api.createRecord('1f3911ff', component.options)
    } else {
      api.reload('1f3911ff', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1f3911ff&scoped=true", function () {
      api.rerender('1f3911ff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Problem/complaintWorkOrder/index.vue"
export default component.exports